import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal } from "../components/Reveal";
import PageHero from "../components/PageHero";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        overline="Get in Touch"
        title={<>We&apos;d love to <span className="italic text-gold-gradient">hear</span> from you</>}
        subtitle="Reach out for admissions, campus visits or any queries about our programs."
      />
      <section className="bg-sand py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            {[
              { icon: MapPin, t: "Address", d: "Bahadurpur, Jainamore, Bokaro, Jharkhand" },
              { icon: Phone, t: "Phone", d: "+91 70913 55794  ·  +91 79922 99796", href: "tel:+917091355794" },
              { icon: Mail, t: "Email", d: "svscollegeofnursing@gmail.com", href: "mailto:svscollegeofnursing@gmail.com" },
              { icon: Clock, t: "Office Hours", d: "Monday – Saturday, 9:00 AM – 5:00 PM" },
            ].map((c, i) => (
              <Reveal key={c.t} delay={i * 0.08}>
                <div className="flex gap-5 border-b border-navy/10 pb-8" data-testid={`contact-${c.t.toLowerCase()}`}>
                  <div className="h-12 w-12 rounded-full bg-navy flex items-center justify-center shrink-0">
                    <c.icon size={20} className="text-gold" />
                  </div>
                  <div>
                    <h3 className="font-serif text-xl text-navy mb-1">{c.t}</h3>
                    {c.href ? (
                      <a href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined} className="text-navy/60 hover:text-gold transition-colors break-words">{c.d}</a>
                    ) : (
                      <p className="text-navy/60">{c.d}</p>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="relative overflow-hidden rounded-[2px] h-full min-h-[400px] shadow-[0_20px_60px_rgba(10,30,77,0.12)]">
              <iframe
                title="SVS College of Nursing location"
                src="https://www.google.com/maps?q=Jainamore,Bokaro,Jharkhand&output=embed"
                className="w-full h-full min-h-[400px] border-0"
                loading="lazy"
                data-testid="contact-map"
              />
              <a
                href="https://maps.app.goo.gl/zykA878j1Sy8R5CS6"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="open-in-maps-btn"
                className="absolute bottom-4 right-4 inline-flex items-center gap-2 rounded-full bg-navy text-sand text-sm font-semibold px-5 py-2.5 shadow-lg transition-transform duration-300 hover:scale-105 hover:bg-navy-light"
              >
                <MapPin size={16} className="text-gold" /> Open in Google Maps
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
